import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { MentionPatchModel } from '../../../api/mentions/mentions.api';

import { Mention } from '../../Mentions/models/mention';
import { JournodexGeographyModel } from '../../Journodex/models/journodex-geography.model';


@Injectable()
export abstract class AbstractMentionsService {
    constructor() {}
    abstract getFocusedMention(): Observable<Mention>;
    abstract getMentionRegion(mention: Mention): Observable<JournodexGeographyModel>;
    abstract patchAndReturnMention(diff: MentionPatchModel): Observable<Mention>;
    abstract setFocusedMention(mention: Mention);
}
